import React from "react";
import { Magnetic } from "./Magnetic";

// Magnetic pill button. Renders <a> or <button>.
export const MagneticButton = ({
  children,
  as = "button",
  href,
  onClick,
  variant = "primary",
  className = "",
  "data-testid": testid,
  type = "button",
}) => {
  const base =
    "relative inline-flex items-center justify-center gap-2 rounded-full px-5 py-2.5 text-[0.8rem] font-semibold tracking-wide transition-[background-color,color,box-shadow,border-color] duration-300 will-change-transform md:px-6 md:py-3 lg:px-7 lg:py-3.5 lg:text-sm";
  const variants = {
    primary:
      "bg-amber text-ink hover:bg-gold shadow-[0_0_0_0_rgba(245,158,11,0)] hover:shadow-[0_10px_40px_-8px_rgba(245,158,11,0.6)]",
    ghost:
      "bg-white/5 text-foreground border border-white/12 hover:border-amber/60 hover:bg-white/8",
    outline:
      "bg-transparent text-amber border border-amber/40 hover:bg-amber/10",
  };
  const cls = `${base} ${variants[variant]} ${className}`;

  const inner =
    as === "a" ? (
      <a href={href} onClick={onClick} className={cls} data-testid={testid} target={href?.startsWith("http") ? "_blank" : undefined} rel={href?.startsWith("http") ? "noopener noreferrer" : undefined}>
        {children}
      </a>
    ) : (
      <button type={type} onClick={onClick} className={cls} data-testid={testid}>
        {children}
      </button>
    );

  return <Magnetic strength={0.35}>{inner}</Magnetic>;
};
